module.exports = __webpack_public_path__ + "img/play.bf8d8aea.svg";